import React from 'react';
import styled from 'styled-components';
import { StatsTilesContainer, StatsContentContainer } from '../components/Card';
import Button from '@material-ui/core/Button';
import Link from 'next/link';
import { PageWithTitle } from '../components/PageWithoutTitle';

import { RouterConfig } from '../config/router';

interface MenuItem {
  title: string;
  over: RouterConfig;
  under: RouterConfig;
}
interface UnderOverMenuProps {
  menu: MenuItem[];
  title: string;
}

const StyledContainer = styled.section`
  display: grid;
  grid-template-columns: 1fr auto 1fr;
  padding: 0.5rem clamp(0.5rem, 1rem, 5rem);
`;

const FlexContainer = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
`;
const Circle = styled.div`
  height: 35px;
  width: 35px;
  border: 1px solid #bbb;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const GreyLine = styled.span<{ value: number }>`
  display: block;
  height: 1px;
  background-color: ${({ theme }) => theme.SimpleButtonBorderColor};
  width: ${({ value }) => `${value}%`};
  border-radius: 10px;
`;

const BoldText = styled.span`
  text-align: center;
  font-weight: bold;
  color: ${({ theme }) => theme.colorLight};
`;

const StyledLink = styled.a`
  padding: 5px 15px;
`;
const ColorButton = styled(Button)`
  &&& {
    &.MuiButton-root,
    &.MuiButtonBase-root {
      background-color: transparent;
      border-color: ${({ theme }) => theme.SimpleButtonBorderColor};
      color: ${({ theme }) => theme.colorLight};
      border-radius: 25px;
      transition: 0.1s ease-in;
      min-width: 80px;
      padding: 0;

      &:hover {
        background-color: ${({ theme }) => theme.colorActive};
        color: white;
        border-color: ${({ theme }) => theme.SimpleButtonBorderColor};
      }
    }
  }
`;
export const UnderOverMenu = ({ menu, title }: UnderOverMenuProps) => {
  return (
    <StatsTilesContainer>
      <PageWithTitle title={title} />

      <StatsContentContainer>
        {menu.map((item) => {
          return (
            <StyledContainer key={item.title}>
              <FlexContainer>
                <ColorButton variant="outlined" color="primary">
                  <Link href={item.under} passHref>
                    <StyledLink>Under</StyledLink>
                  </Link>
                </ColorButton>
                <GreyLine value={100} />
              </FlexContainer>
              <FlexContainer>
                <Circle>
                  <BoldText>{item.title}</BoldText>
                </Circle>
              </FlexContainer>
              <FlexContainer>
                <GreyLine value={100} />
                <ColorButton variant="outlined" color="primary">
                  <Link href={item.over} passHref>
                    <StyledLink>Over</StyledLink>
                  </Link>
                </ColorButton>
              </FlexContainer>
            </StyledContainer>
          );
        })}
      </StatsContentContainer>
    </StatsTilesContainer>
  );
};
